var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-default-svg-from-material-design',{attrs:{"size":_vm.size,"keep-y-zero":_vm.keepYZero,"path":"M22,4A2,2 0 0,1 24,6V16A2,2 0 0,1 22,18H6A2,2 0 0,1 4,16V4A2,2 0 0,1 6,2H12L14,4H22M2,6V20H20V22H2A2,2 0 0,1 0,20V11H0V6H2M6,6V16H22V6H6Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }